<template>
    <div>
        <b-button @click="openModal()">Unprinted Documents</b-button>
        <b-modal size="xl"
                 centered
                 no-close-on-backdrop
                 no-close-on-esc
                 v-model="modalOpen"
                 @shown="resetModal"
                 v-on:cancel="resetModal()">
            <template #modal-header>
                <h5 class="modal-title">Print Queue</h5>
            </template>

            <template #default>
                <print-queue :api-base-url="apiBaseUrl"
                                       :all-audio-sub-status-options="allAudioSubStatusOptions"
                                       :all-log-notes-sub-status-options="allLogNotesSubStatusOptions"
                                       :all-release-approval-sub-status-options="allReleaseApprovalSubStatusOptions"
                                       :all-deposit-sub-status-options="allDepositSubStatusOptions"
                                       :all-vetting-sub-status-options="allVettingSubStatusOptions"
                                       :all-delivered-late-reason-options="allDeliveredLateReasonOptions"></print-queue>
            </template>

            <template #modal-footer="{ cancel }">
                <button type="button" class="btn btn-secondary" @click="cancel()" :disabled="busy">Close</button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import ErrorsMixin from '../mixins/ErrorsMixin';

    Vue.use(BootstrapVue);

    export default {
        name: 'printQueueModal',
        mixins: [ErrorsMixin],
        provide: {
            grid: []
        },
        props: {
            apiBaseUrl: {
                type: String,
                required: true
            },
            allAudioSubStatusOptions: {
                type: Array,
                default: null
            },
            allLogNotesSubStatusOptions: {
                type: Array,
                default: null
            },
            allReleaseApprovalSubStatusOptions: {
                type: Array,
                default: null
            },
            allDepositSubStatusOptions: {
                type: Array,
                default: null
            },
            allVettingSubStatusOptions: {
                type: Array,
                default: null
            },
            allDeliveredLateReasonOptions: {
                type: Array,
                default: null
            },
        },
        data: function () {
            return {
                modalOpen: false,
                busy: false
            };
        },
        methods: {
            openModal: function () {
                this.modalOpen = true;
            },
            resetModal: function () {
                return;
            },
        },
        mounted: function () {
        }

    }
</script>

